// src/api/forecast.client.js
import axios from "axios";
const api = axios.create({
	baseURL: process.env.REACT_APP_CORE_URL,
	withCredentials: true, // Para enviar cookies automáticamente con cada solicitud
});

// 1) Crear / importar un forecast (paso 1 del modal)
export async function createForecastFile({ site_id, start, end, nombre, forecast_origin }) {
	const { data } = await api.post("/forecast-files/create_forecast_file", {
		site_id,
		start,
		end,
		nombre,
		forecast_origin,
	});
	return data; // = JSON por meses con días/horas (el que usas en el paso 2)
}

// 2) Listado para la tabla del módulo
export async function listForecasts(site_id) {
	const { data } = await api.get(`/forecast-files/get_forecast_file`, { params: { site_id } });

	return data; // = [{id, nombre, start_dtm, end_dtm, origen}, ...]
}

// 3) Listado para el modal de lanzar simulación (con filtros)
export async function listForecastFilesForSim({ site_id, start_date, end_date, origin }) {
	const { data } = await api.get(`/forecast-files/get_forecast_file`, {
		params: { site_id, start_date, end_date, origin },
	});
	return data; // = mismo shape que listForecasts, pero filtrado
}

// 4) Obtener el contenido de un forecast particular (para "Editar")
export async function getForecastFile({ site_id, file_id }) {
	const { data } = await api.get(`/forecast-files/get_forecast_file_gcs`, {
		params: { site_id, file_id },
	});

	return data; // = JSON por meses con días/horas (igual al de "crear")
}

// 5) Actualizar un forecast existente
export async function updateForecastFile({ site_id, file_id, body }) {
	const { data } = await api.post(`/forecast-files/update_forecast_file`, body, {
		params: { site_id, file_id },
	});

	return data;
}

export async function deleteForecastFile({ site_id, file_id }) {
	const { data } = await api.delete(
		`/forecast-files/delete_forecast_file/${file_id}?site_id=${site_id}`
	);
	return data;
}
